import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Slider,
} from "@mui/material";
import React, { useState } from "react";
import Header from "../header";

import { Rating } from "react-simple-star-rating";

export const FilterComp = ({
  changeDistance,
  approved,
  distance,
  filterModalToggler,
  submitFilters,
  type,
  filterType,
  filterRate,
  setApproved,
}) => {
  const [active, setActive] = useState("static");
  if (approved === undefined) {
    setApproved(0);
  }
  return (
    <>
      <Header
        showSearchBar={true}
        backHandler={filterModalToggler}
        title={"انتخاب فیلتر"}
      />
      <div className="serviceFilterWrapper">
        <div>
          <div className="carFilterSliderBox">
            <label>فاصله</label>
            <Slider
              min={1}
              max={5}
              onChange={changeDistance}
              value={[distance[0], distance[1]]}
              className="priceRangeSlider"
            />

            <div className="priceRangeNum">
              <span>{distance[1]} کیلومتر</span>
              <span>{distance[0]} کیلومتر</span>
            </div>
          </div>
          <div className="filterRating">
            <span> امتیاز کسب شده توسط سرویس کار</span>
            <div className="garageFilterRating">
              <Rating
                onClick={(e) => filterRate(e)}
                readonly={false}
                fillColor="#87C6BF"
                rtl
                size={30}
                SVGstorkeWidth={5}
              />
            </div>
          </div>
          <div className="filterServiceType">
            <FormControl sx={{ width: "100%" }}>
              <FormLabel
                id="demo-radio-buttons-group-label"
                className="radioTitle"
              >
                نوع سرویس
              </FormLabel>
              <RadioGroup
                className="reservceRadioButtons"
                sx={{ width: "100%" }}
                row={true}
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="static"
                name="radio-buttons-group"
                onChange={(e) => {
                  filterType(e.target.value);
                  setActive(e.target.value);
                }}
              >
                <FormControlLabel
                  className={`serviceTyperadioButton ${
                    active === "static" ? "activeRadio" : ""
                  }`}
                  value="static"
                  control={<Radio />}
                  label="ثابت"
                />
                <FormControlLabel
                  className={`serviceTyperadioButton ${
                    active === "dynamic" ? "activeRadio" : ""
                  }`}
                  value="dynamic"
                  control={<Radio />}
                  label="سیار"
                />
              </RadioGroup>
            </FormControl>
            <div className="approvedByKachar">
              <span className="approvedTitle">مورد تایید کاچار</span>
              <label className="switch">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setApproved(1);
                    } else {
                      setApproved(0);
                    }
                  }}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>
        <div
          className="serviceBtnFilter"
          onClick={() => {
            submitFilters();
          }}
        >
          تایید
        </div>
      </div>
    </>
  );
};
